import gql from "graphql-tag";

// Sets completedAt when the deck finishes; skipping leaves it null, so completed vs abandoned
// stays visible in the data. The "now()" literal matches UpsertUserProjectViewMutation's viewedAt.
const UpdateUserWelcomeFlowCompletedMutation = gql`
  mutation UpdateUserWelcomeFlowCompleted($flowKey: String!) {
    update_userWelcomeFlow(where: { flowKey: { _eq: $flowKey } }, _set: { completedAt: "now()" }) {
      affected_rows
    }
  }
`;

export default UpdateUserWelcomeFlowCompletedMutation;
